import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { supabase } from '../lib/supabase'

interface Props {
  onClose: () => void
  user?: any
}

export function PremiumModal({ onClose, user }: Props) {
  const { t } = useTranslation()
  const [plan, setPlan] = useState<'monthly'|'annual'>('annual')
  const [loading, setLoading] = useState(false)

  const handleSubscribe = async () => {
    if (!user) {
      window.location.href = '/auth?next=premium'
      return
    }
    setLoading(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const refCode = localStorage.getItem('affiliate_ref')
      const { data, error } = await supabase.functions.invoke('create-checkout', {
        body: { user_id: user.id, email: user.email, ref_code: refCode, plan },
        headers: { Authorization: 'Bearer ' + session?.access_token }
      })
      if (error) throw error
      if (data?.url) window.location.href = data.url
    } catch (err: any) {
      alert('Errore: ' + err.message)
    }
    setLoading(false)
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: 24, padding: 32, maxWidth: 400, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>✦</div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', marginBottom: 4 }}>Premium</h2>
          <p style={{ color: '#6B7280', fontSize: 15 }}>Sblocca le funzionalità avanzate</p>
        </div>

        {/* Features */}
        <div style={{ marginBottom: 24 }}>
          {[
            t('premium.feature1'),
            t('premium.feature2'),
          ].map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{ width: 22, height: 22, borderRadius: '50%', backgroundColor: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ color: '#1c3fff', fontSize: 12, fontWeight: 700 }}>✓</span>
              </div>
              <span style={{ color: '#374151', fontSize: 14 }}>{f}</span>
            </div>
          ))}
        </div>

        {/* Piani */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          <button onClick={() => setPlan('monthly')} style={{ flex: 1, padding: '14px 8px', borderRadius: 12, border: plan === 'monthly' ? '2px solid #1c3fff' : '1px solid #E5E7EB', backgroundColor: plan === 'monthly' ? '#EEF2FF' : 'white', cursor: 'pointer' }}>
            <div style={{ fontWeight: 700, fontSize: 18, color: '#111827' }}>€2,99</div>
            <div style={{ fontSize: 12, color: '#6B7280' }}>al mese</div>
          </button>
          <button onClick={() => setPlan('annual')} style={{ flex: 1, padding: '14px 8px', borderRadius: 12, border: plan === 'annual' ? '2px solid #1c3fff' : '1px solid #E5E7EB', backgroundColor: plan === 'annual' ? '#EEF2FF' : 'white', cursor: 'pointer', position: 'relative' }}>
            <div style={{ position: 'absolute', top: -10, right: 6, backgroundColor: '#10B981', color: 'white', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 10 }}>-22%</div>
            <div style={{ fontWeight: 700, fontSize: 18, color: '#111827' }}>€27,99</div>
            <div style={{ fontSize: 12, color: '#6B7280' }}>all'anno</div>
            <div style={{ fontSize: 11, color: '#10B981', fontWeight: 600 }}>€2,33/mese</div>
          </button>
        </div>

        <button onClick={handleSubscribe} disabled={loading} style={{ width: '100%', backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 14, padding: '14px 0', fontSize: 16, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
          {loading ? t('premium.loading') : user ? t('premium.cta') : t('premium.ctaLogin')}
        </button>

        <button onClick={onClose} style={{ width: '100%', backgroundColor: 'transparent', color: '#9CA3AF', border: 'none', borderRadius: 14, padding: '10px 0', fontSize: 14, cursor: 'pointer' }}>
          No grazie
        </button>
      </div>
    </div>
  )
}
